.group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin-bottom: var(--sp-8);
}
.chip {
  padding: var(--sp-2) var(--sp-4);
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--surface-raised);
  font-weight: 600;
  color: var(--text-strong);
}
.chip:hover {
  border-color: var(--border-strong);
}
.chip[aria-pressed="true"] {
  background: var(--text-strong);
  border-color: var(--text-strong);
  color: var(--surface);
}
.count {
  margin-left: 0.5em;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  opacity: 0.65;
}
